var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "story-maker-sticker story-maker-sticker-gif" },
    [
      _c("img", {
        staticClass: "img-change-color",
        attrs: { src: require("@/assets/img/instagram/ehf.png") },
      }),
      _c("p", { staticClass: "text-finish" }, [
        _vm._v(_vm._s(_vm.$t("dash.post-creator.story.done"))),
      ]),
      _c("div", { staticClass: "sticker-gif" }, [
        _c("img", {
          staticClass: "selectDisable",
          class:
            parseInt(_vm.stickerInstance.data.gif.images.original.heigth) >
            parseInt(_vm.stickerInstance.data.gif.images.original.width)
              ? "set-width"
              : "set-height",
          attrs: {
            draggable: "false",
            "data-check-load": "",
            src: _vm.stickerInstance.data.gif.images.original.url,
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }